<template>
  <pagination :status="pagination" @change-page="$emit('change-page', $event)" @change-per-page="$emit('change-per-page', $event)">
    <addition-button v-if="canRegister" @click="$emit('register')" />
  </pagination>
  <table class="table table-bordered table-striped table-hover mb-2">
    <table-head :headers="headers" :sort="sort" @sort="$emit('sort', $event)" />
    <table-body :columns="columns" :data="data" :setStyle="setStyle" @select="$emit('select', $event)" :selectable-rows="selectableRows" />
  </table>
  <pagination :status="pagination" @change-page="$emit('change-page', $event)" @change-per-page="$emit('change-per-page', $event)" />
</template>

<script>
import Pagination from '@/views/molecules/Pagination';
import TableHead from "@/views/atoms/table/TableHead";
import TableBody from "@/views/atoms/table/TableBody";
import AdditionButton from '@/views/molecules/buttons/AdditionButton';

export default {
  name: "PlainTable",
  components: {
    AdditionButton,
    Pagination,
    TableHead,
    TableBody,
  },
  props: {
    headers: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
    sort: {
      type: Object,
      required: true,
    },
    canRegister: {
      type: Boolean,
      default: false,
    },
    selectableRows: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['select', 'register', 'change-page', 'change-per-page', 'sort'],
  computed: {
    columns() {
      return this.headers.map(header => header.column);
    },
    setStyle() {
      return this.headers.map(header => header.setStyle);
    }
  },
}
</script>
